var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{style:({border: ("1px solid " + _vm.color)}),attrs:{"buffer-value":"0","stream":"","rounded":"","value":_vm.value,"color":_vm.color,"height":"25"},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_c('strong',[_vm._v(_vm._s(Math.round(value * 100) / 100)+"%")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }